import settingsScreens from './tailwind.settings.screens.js';
import settingsFontSizes from './tailwind.settings.fontSizes.js';
import defaultTheme from 'tailwindcss/defaultTheme';

export default {
    mode: 'jit',
    content: [
        "./css/**/*.{html,js,php,css,blade.php,vue,txt}",
        "./js/**/*.{html,js,php,css,blade.php,vue,txt}",
        "./views/**/*.{html,js,php,css,blade.php,vue,txt}",
    ],

    darkMode: 'class',
    theme: {
        extend: {
            animation: {
                'fade-border': 'fade-border 3s infinite',
            },
            keyframes: {
                'fade-border': {
                    '0%, 100%': {borderColor: 'transparent'},
                    '50%': {borderColor: 'rgba(0, 0, 0, 0.5)'},
                },
            },
        },
        fontFamily: {
            'body': ['Montserrat'],
        },
        container: {
            padding: {
                DEFAULT: '5px',
                sm: '5px',
                md: '5px',
                lg: '5px',
                xl: '5px',
            },
        },
        minHeight: theme => ({
            '0': '0',
            ...theme('spacing'),
            full: '100%',
            app: 'var(--appHeight)',
            screen: '100vh'
        }),
        height: theme => ({
            auto: 'auto',
            ...theme('spacing'),
            full: '100%',
            app: 'var(--appHeight)',
            screen: '100vh'
        }),
        maxHeight: theme => ({
            auto: 'auto',
            ...theme('spacing'),
            full: '100%',
            app: 'var(--appHeight)',
            screen: '100vh'
        }),
        screens: {
            'xs': '475px',
            ...defaultTheme.screens,
        },
        fontSize: settingsFontSizes,
        extend: {
            colors: {
                'red': '#FF5252',
                'green': '#4CAF50',
                'white-light': '#FAFCFF',
                'gray-light': '#EEF1F5',
                'blue-dark': '#031837',
                'blue': '#353CEE',
                'blue-light': '#DCDFFC'
            },
            container: {
                padding: '2rem',
            },
            transformOrigin: {
                "0": "0%",
            },
            transitionProperty: {
                'width': 'width'
            },
            zIndex: {
                "-1": "-1",
            },
            variants: {
                borderColor: ['responsive', 'hover', 'focus', 'focus-within'],
            },
            borderRadius: {
                'md': '0.3125rem',
            },
            lineClamp: {
                7: '7',
                8: '8',
                9: '9',
                10: '10',
                11: '11',
                12: '12',
            },

            '.overflow-y-auto': {
                scrollbarWidth: 'thin', /* Breite der Scrollleiste */
                scrollbarColor: '#353CEE #f1f1f1', /* Farbe des Daumens und Hintergrundfarbe des Trackers */
            },
        },
    }, plugins: [
        function ({addBase}) {
            addBase({
                'em':
                    {
                        lineHeight: '0',
                        transform: 'scaleY(0.1)',
                        marginBottom: '-0.2rem'
                    },

            });
        },
    ],
};
